<script>
    import { t } from '$lib/i18n.js';

    export let name;
    export let price;
    export let currency;
    export let stars;
    export let image;
    export let imageAlt;

    export let userId;
    export let carId;

    // Capitalize the first letter of the name
    $: name = name.charAt(0).toUpperCase() + name.slice(1);
</script>

<a href='/car/{userId}/{carId}'>
    <img src={image} alt={imageAlt} />
    <h3>{name}</h3>
    
    <div class="row">
        <p>⭐️ {stars}</p>
        <p class="price"><b class="accent">{currency} {price}</b> / {$t('words.day')}</p> 
    </div>
</a>

<style>
    a {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        overflow: hidden;
        gap:16px;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }

    img {
        width: 100%;
        height: 250px;
        border-radius: 24px;
        background-color: var(--surface-container);
        object-fit: cover;
    }

    h3 {
        font-family: var(--font-body);
        font-size: 20px;
        width: 100%;
        margin: 0;
        padding: 0;
        margin-top: 4px;
        text-overflow: ellipsis;
        word-wrap: break-word;
        overflow: hidden;
        max-height: 1.1em;
        line-height: 1.1em;
        font-weight: 600;
        letter-spacing: -0.5px;
    }

    p {
        font-size: 16px;
        margin: 0;
        padding: 0;
        color: var(--on-surface-75);
    }

    p.price {
        color: var(--surface);
        font-weight: regular;
        font-size: 12px;
        line-height: 1;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 6px;
        padding-bottom: 6px;
        background-color: var(--orange); 
        border-radius: 16px;
        text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 1.5em;
    }

    p.price b.accent {
        color: var(--surface);
        font-weight: 500;
        font-size: 16px;
    }
</style>